import { themeVars } from '../theme/vars.ts';
import { space } from '../tokens.ts';
import { globalStyle, style, styleVariants } from '../layer.css';

export const carouselContentContainer = style({
  overflow: 'hidden',
});

export const carouselContent = style({
  display: 'flex',
  gap: space.s10,
});

export const carouselContentVariants = styleVariants({
  horizontal: {
    flexDirection: 'row',
    touchAction: 'pan-y pinch-zoom',
  },
  vertical: {
    flexDirection: 'column',
    touchAction: 'pan-x pinch-zoom',
  },
});

export const carouselItem = style({
  flexShrink: 0,
  flexGrow: 0,
  flexBasis: '100%',
});

globalStyle(`img:where(${carouselItem} > img)`, {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
});

export const carouselButton = style({
  height: '2rem',
  width: '2rem',
  borderRadius: 9999,
});

export const carouselTrigger = style({
  border: 0,
  background: 'none',
  padding: 0,
  cursor: 'pointer',
});

export const carouselDots = style({
  display: 'flex',
  alignItems: 'center',
  gap: space.s12,
});

export const carouselDot = style({
  height: 8,
  width: 8,
  borderRadius: 9999,
  backgroundColor: themeVars.color.bgFill.interactive.secondary.default,

  selectors: {
    '&[data-active]': {
      backgroundColor: themeVars.color.bgFill.interactive.secondary.active,
    },
  },
});
